module.exports = __webpack_public_path__ + "img/instagram.d3fce3e5.svg";